import { FaCircleCheck } from "react-icons/fa6";
import { HiOutlineBolt } from "react-icons/hi2";

import StacstartImg from "assets/png/stacstart.png";

const features = [
  "Assess talent based on practical capability",
  "Track readiness and performance",
  "Map competencies to real-world skills",
  "Match talent to real project opportunities",
];

const Stacstart = () => {
  return (
    <div className="w-full px-6 bg-white sm:px-10 xl:px-20 py-14 xl:py-20">

      {/* Title — ABOVE the two columns */}
      <h2 data-aos="fade-up" className="text-[28px] sm:text-[32px] xl:text-[36px] font-black text-[#0E1421] leading-tight flex flex-wrap items-center gap-2 mb-8">
        Stacstart
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-[#3B5BDB] text-[#3B5BDB] text-sm font-semibold bg-white whitespace-nowrap">
          <HiOutlineBolt className="w-3.5 h-3.5" />
          AI-Powered
        </span>
        Talent Engine
      </h2>

      {/* Two-column layout */}
      <div className="flex flex-col items-center gap-10 xl:flex-row xl:gap-16 xl:items-center">

        {/* Left: Image inside grey card */}
        <div data-aos="fade-up" data-aos-duration="800" className="w-full xl:flex-1 flex items-center justify-center">
          <img
            src={StacstartImg}
            alt="Stacstart platform"
            loading="lazy"
            className="object-contain w-full rounded-xl"
          />
        </div>

        {/* Right: Content (no title here) */}
        <div data-aos="fade-up" data-aos-duration="800" data-aos-delay="100" className="w-full xl:max-w-[460px] flex flex-col gap-5">

          {/* Description */}
          <p className="text-[15px] leading-relaxed text-[#3D3D3D]">
            Stacstart is the talent development arm of the Conclase ecosystem,
            built as an AI-powered platform for training, assessing, and
            deploying technology talent.
          </p>

          {/* Feature list */}
          <div className="flex flex-col gap-3 mt-1">
            {features.map((f, i) => (
              <div key={f} data-aos="fade-up" data-aos-delay={`${200 + i * 80}`} className="flex items-start gap-3">
                <FaCircleCheck className="text-[#F5C518] mt-0.5 shrink-0 w-5 h-5" />
                <p className="text-[15px] text-[#1A1A1A] font-medium">{f}</p>
              </div>
            ))}
          </div>

          {/* Buttons */}
          <div className="flex flex-col gap-3 mt-4">
            <a
              href="https://stacstart.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full py-4 bg-[#F5C518] text-[#0E1421] text-[15px] font-bold rounded-full hover:brightness-95 transition-all text-center"
            >
              Explore Stacstart
            </a>
            <a
              href="https://stacstart.com/jobs"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full py-4 bg-white text-[#3B5BDB] text-[15px] font-semibold rounded-full border-2 border-[#3B5BDB] hover:bg-[#EEF2FF] transition-all text-center"
            >
              Explore Stacstarts Job
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stacstart;